module.exports = __webpack_public_path__ + "static/background_secondary-eed7ba73adf2ba32280c1945a44eba7e.png";